'use client';
import type { ReactElement } from 'react';
import type { Node } from '@xyflow/react';
import { FlowchartCompactPreviewNode } from './FlowchartCompactPreviewNode';
import type { FlowchartNodeData } from './flowchart-types';
import { dataEl, type DataElScope } from '@/utils/dataEl';
const PREVIEW_NODE_LIMIT = 3;
const PREVIEW_CONTAINER_GAP = 6;
interface FlowchartCompactPreviewProps {
    dataElScope: DataElScope;
    nodes: Array<Node<FlowchartNodeData>>;
}
export function FlowchartCompactPreview({ dataElScope, nodes, }: FlowchartCompactPreviewProps): ReactElement | null {
    const previewNodes = nodes.slice(0, PREVIEW_NODE_LIMIT);
    if (previewNodes.length === 0) {
        return null;
    }
    return (
      <div data-el={dataEl(dataElScope, 'FlowchartCompactPreview/Root')} style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: PREVIEW_CONTAINER_GAP,
            height: '100%',
            paddingBottom: 26,
        }}>
        {previewNodes.map((node, previewNodeIndex) => (<FlowchartCompactPreviewNode dataElScope={dataElScope} key={node.id} hasConnector={previewNodeIndex < previewNodes.length - 1} isEnd={previewNodeIndex === previewNodes.length - 1 && previewNodes.length > 2} isStart={previewNodeIndex === 0} label={node.data.label}/>))}
      </div>
    );
}
